import { allowed_3d, allowed_2d } from '../files/file-extensions';
export const STL_MANUFACTURING_TYPE = '3D PRINTING';
export const isStlFile = (filename) => {
    if (!filename)
        return false;
    const extension = filename.split('.').pop();
    return extension?.toLowerCase() === 'stl';
};
export const is3dFileAllowedForManufacturingType = (filename, manufacturingType) => {
    if (!isStlFile(filename))
        return true;
    if (!manufacturingType)
        return true;
    return manufacturingType === STL_MANUFACTURING_TYPE;
};
export const buildManufacturingTypePayloadForStlPart = (part, manufacturingType) => {
    const payload = {
        id: part.id,
        manufacturing_type: manufacturingType,
    };
    const currentMaterial = part?.product?.material_related;
    const hasRealSelectedMaterial = Boolean(currentMaterial?.id);
    const currentMaterialStillValid = !hasRealSelectedMaterial ||
        (Array.isArray(currentMaterial?.manufacturing_types) &&
            currentMaterial?.manufacturing_types?.includes(manufacturingType));
    if (!currentMaterialStillValid) {
        payload.product = {
            material: null,
            custom_material: '',
        };
        payload.material = null;
    }
    return payload;
};
export const is3dFile = (filename) => {
    const extension = filename.split('.').pop();
    const allowed = allowed_3d
        .split(',')
        .map(ext => ext.trim())
        .filter(Boolean);
    return allowed.find(ext => ext.toLowerCase() === extension?.toLowerCase());
};
export const is2dFile = (filename) => {
    const extension = filename.split('.').pop();
    const allowed = allowed_2d
        .split(',')
        .map(ext => ext.trim())
        .filter(Boolean);
    return allowed.find(ext => ext.toLowerCase() === extension?.toLowerCase());
};
export const get_name = (filename) => {
    if (!filename)
        return '';
    // Handle cases where a full path is passed in.
    const baseName = filename.split('/').pop() ?? filename;
    // Remove extension (if any) and strip non-alphanumeric characters.
    const withoutExtension = baseName.includes('.') ? baseName.split('.').slice(0, -1).join('.') : baseName;
    return withoutExtension.replace(/[^0-9a-z]/gi, '');
};
